import styled from 'styled-components'

export const PageLoadingContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  height: calc(100% - 24px);
  width: 100%;
`
